import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as healthCheck from '../../health-check'

export const RESOURCE = {
  payload: {
    description:
      'Questions that are used to evaluate an organization’s performance in a specific dimension.',
    dimension: healthCheck.RESOURCE.payload,
    level: 3,
    name: 'Criteria',
    partialId: PartialId.Standard.create('criteria'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
